import $ from 'jquery';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import axios from 'axios';
import {
    GET_ALL_INVOICES,
    GET_INVOICE_DETAILS,
    GENERATE_INVOICE_PDF,
    get_headers,

} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';


export default {
    name: 'InvoiceManagement',
    mixins: [alert_mixin, formatting_mixins],
    data: () => ({
        headers: get_headers(),
        project_id: sessionStorage.getItem('project_id'),
        lead_id: null,
        invoices: [],
        openAccordions: [],
        main_service: [
            {
                id: null,
                name: '',
                qty: null,
                unit_price: 0.00,
                vat: 0.00,
                total: 0.00,
                sub_services: [
                    {
                        id: null,
                        name: '',
                        qty: null,
                        unit_price: null,
                        vat: null,
                        total: null
                    }
                ]
            },
        ],
        preview_invoice_url:'',
        selected_invoice_id:null,
        invoice_status:''

    }),
    mounted() {
        this.lead_id =
            this.$route.params.lead_id ??
            this.$route.params.id ??
            this.$route.query.lead_id ??
            null;

        if (!this.lead_id) {
            this.show_error("No lead ID found. Check your route.");
        }
        this.get_invoices()

    },
    methods: {


        destroy_data_table() {
            if (this.dataTable) {
                this.dataTable.destroy();
                this.dataTable = null;
            }
        },


        get_invoices() {
            this.destroy_data_table();
            this.invoices = [];
            axios.get(GET_ALL_INVOICES, {
                headers: this.headers,
                params: { lead_id: this.lead_id }
            })
                .then(response => {
                    const parsed_response = response.data;
                    if (parsed_response.data && parsed_response.data.length > 0) {
                        this.invoices = parsed_response.data;
                        this.transform_invoices_data();
                    } else {
                        this.invoices = [];
                    }
                })
                .catch(error => {
                    this.show_error("Error loading invoices: " + (error.response?.data?.message || error.message));
                });
        },

        get_invoice_details(invoice_id) {

            axios.get(GET_INVOICE_DETAILS, {
                headers: this.headers,
                params: { invoice_id: invoice_id }
            })
                .then(response => {
                    const parsed_response = response.data;

                    if (parsed_response.data && parsed_response.data.length > 0) {
                        this.main_service = parsed_response.data.map(item => {
                        // Case 1: service_package exists → treat it as main service with sub_services
                        if (item.service_package) {
                            const pkg = item.service_package;
                            return {
                            id: pkg?.id ?? null,
                            name: pkg?.name ?? '',
                            qty: pkg?.qty ?? null,
                            unit_price: pkg?.unit_price ?? 0.00,
                            vat: pkg?.vat ?? 0.00,
                            total: parseFloat(pkg?.total) || 0.00,
                            sub_services: (pkg?.sub_services || []).map(sub => ({
                                id: sub?.id ?? null,
                                name: sub?.name ?? '',
                                qty: sub?.qty ?? null,
                                unit_price: sub?.unit_price ?? null,
                                vat: sub?.vat ?? null,
                                total: sub?.total ?? null,
                            }))
                            };
                        }

                        // Case 2: service_item exists → treat it directly as a main service
                        if (item.service_item) {
                            const service = item.service_item;
                            return {
                            id: service?.id ?? null,
                            name: service?.name ?? '',
                            qty: item?.qty ?? null,
                            unit_price: service?.unit_price ?? 0.00,
                            vat: service?.vat ?? 0.00,
                            total: parseFloat(item?.amount) || 0.00,
                            sub_services: []
                            };
                        }

                        });
                    } else {
                        this.invoices = [];
                    }
                })
                .catch(error => {
                    this.show_error("Error loading invoices items: " + (error.response?.data?.message || error.message));
                });
        },

        preview_invoice(invoice) {
            this.selected_invoice_id = invoice.id
            this.invoice_status = invoice.invoice_status.code

            axios.get(GENERATE_INVOICE_PDF, {
                headers: this.headers,
                params: {
                    invoice_id: this.selected_invoice_id,
                    preview_invoice: true
                }
            })
            .then(response => {
                const parsed_response = response.data;
                if (parsed_response.data && parsed_response.data.invoice_url) {
                    this.preview_invoice_url = parsed_response.data.invoice_url
                }
            })
            .catch(error => {
                this.show_error("Error loading invoices: " + (error.response?.data?.message || error.message));
            });
        },
        send_invoice() {
            axios.get(GENERATE_INVOICE_PDF, {
                headers: this.headers,
                params: {
                    invoice_id: this.selected_invoice_id,
                    preview_invoice: false
                }
            })
            .then(response => {
                const parsed_response = response.data;
                if (parsed_response.data.status === 'success') {
                    this.show_success("Invoice sent successfully ")
                    this.get_invoices()

                }
            })
            .catch(error => {
                this.show_error("Error loading invoices: " + (error.response?.data?.message || error.message));
            });
        },

        toggle_accordion(id) {
            const index = this.openAccordions.indexOf(id);
            if (index > -1) {
                this.openAccordions.splice(index, 1);
            }
            else {
                this.openAccordions.push(id);
            }
        },

        format_currency(amount) {
            if (amount === null || amount === undefined) return '-';
            return `R${amount.toFixed(2)}`;
        },


        initialize_data_table() {
            this.$nextTick(() => {
                const table_id = '#invoices_table';
                const table = $(table_id);

                if (table.length === 0) {
                    return;
                }

                // Destroy the existing DataTable instance if it exists
                if ($.fn.DataTable.isDataTable(table)) {
                    table.DataTable().clear().destroy();
                }

                // Store the DataTable instance
                this.dataTable = table.DataTable({
                    responsive: true,
                    autoWidth: false,
                    pageLength: 10
                });
            });
        },

        transform_invoices_data() {
            if (this.invoices.length > 0) {
                const TABLE_FORM_DATA = this.invoices.map(invoice => ({
                    "id": invoice.id,
                    "invoice_number": invoice.invoice_number,
                    "code": invoice.invoice_status.code,
                    "date_issued": this.format_date(invoice.date_issued),
                    "due_date": this.format_date(invoice.due_date),
                    "date_created": this.format_date(invoice.date_created)
                }));
                this.form_table_headers = Object.keys(TABLE_FORM_DATA[0]);
                this.table_safe_form_list = TABLE_FORM_DATA;
            }
            this.$nextTick(() => {
                this.initialize_data_table();
            });

        },
        
        view_payment(invoice) {
            // Use router to navigate to ProofOfPayment page
            const leadId = invoice.lead_id || this.lead_id; // fallback if not in invoice
             this.$router.push({
                path: "/payment_approval",
                query: { lead_id: leadId,invoice_id: invoice.id   }
            });
        },

    }
};
